/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {CreateByNameRequest} from "../model/create-by-name-request";
import {DeleteBatchMediasetRequest} from "../model/delete-batch-mediaset-request";
import {DeleteMediasetRequest} from "../model/delete-mediaset-request";
import {DuplicateMediasetRequest} from "../model/duplicate-mediaset-request";
import {GetAffectedEntitiesWhenRemoveMediaAndAllLinksResponse} from "../model/get-affected-entities-when-remove-media-and-all-links-response";
import {ListData} from "../model/list-data";
import {Media} from "../model/media";
import {Mediaset} from "../model/mediaset";
import {MediaType} from "../model/media-type";
import {RemoveMediaAndAllLinksRequest} from "../model/remove-media-and-all-links-request";
import {SaveMediasetResponse} from "../model/save-mediaset-response";
import {SearchParamRequest} from "../model/search-param-request";
import {SuccessCreateResponse} from "../model/success-create-response";
import {SuccessResponse} from "../model/success-response";
import {UpdateAudioMetaDataRequest} from "../model/update-audio-meta-data-request";
import {UpdateMediaResponse} from "../model/update-media-response";

@Injectable({
    providedIn: "root",
})
export class SimMediasetService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public createMediaset(mediasetRequest: CreateByNameRequest) {
        return super.post<SuccessCreateResponse>(`/api/Mediaset/CreateMediaset`, mediasetRequest);
    }

    public deleteBatchMediaset(request: DeleteBatchMediasetRequest) {
        return super.post<SuccessResponse>(`/api/Mediaset/DeleteBatchMediaset`, request);
    }

    public deleteMediaset(mediasetRequest: DeleteMediasetRequest) {
        return super.post<SuccessResponse>(`/api/Mediaset/DeleteMediaset`, mediasetRequest);
    }

    public downloadMediaSet_Url(mediaSetId: string) {
        return super.getUrl(`/api/Mediaset/DownloadMediaSet`, {mediaSetId: mediaSetId});
    }

    public duplicateGlobalMediaSet(mediasetRequest: DuplicateMediasetRequest) {
        return super.post<SuccessResponse>(`/api/Mediaset/DuplicateGlobalMediaSet`, mediasetRequest);
    }

    public duplicateMediaSet(mediasetRequest: DuplicateMediasetRequest) {
        return super.post<SuccessResponse>(`/api/Mediaset/DuplicateMediaSet`, mediasetRequest);
    }

    public fetchFilteredMedia(searchParameters: SearchParamRequest) {
        return super.get<ListData<Media>>(`/api/Mediaset/FetchFilteredMedia`, {searchParameters: searchParameters}, ["searchParameters"]);
    }

    public getAffectedEntitiesWhenRemoveMediaAndAllLinks(mediaIdToRemove: string) {
        return super.get<GetAffectedEntitiesWhenRemoveMediaAndAllLinksResponse>(`/api/Mediaset/GetAffectedEntitiesWhenRemoveMediaAndAllLinks`, {mediaIdToRemove: mediaIdToRemove});
    }

    public getDefaultMediaSet() {
        return super.get<Mediaset>(`/api/Mediaset/GetDefaultMediaSet`, );
    }

    public getFilteredMediaSets(searchTerm: string = null, searchColumn: string = "name", sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<Mediaset>>(`/api/Mediaset/GetFilteredMediaSets`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getMediaById(mediaId: string) {
        return super.get<Media>(`/api/Mediaset/GetMediaById`, {mediaId: mediaId});
    }

    public getMediasetById(mediasetId: string) {
        return super.get<Mediaset>(`/api/Mediaset/GetMediasetById`, {mediasetId: mediasetId});
    }

    public listGlobalMediaSets(searchTerm: string = null, sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<Mediaset>>(`/api/Mediaset/ListGlobalMediaSets`, {searchTerm: searchTerm, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }
/**
 * @deprecated ListMedias is deprecated, please use FetchFilteredMedia instead
 */ 

    public listMedias(mediaType: MediaType = null, searchTerm: string = "", page: number = 0, pageSize: number = 2147483647, sortColumn: string = "name", sortAscending: boolean = true) {
        return super.get<Media[]>(`/api/Mediaset/ListMedias`, {mediaType: mediaType, searchTerm: searchTerm, page: page, pageSize: pageSize, sortColumn: sortColumn, sortAscending: sortAscending});
    }

    public listMediaSets(searchTerm: string = null, sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<Mediaset>>(`/api/Mediaset/ListMediaSets`, {searchTerm: searchTerm, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public removeMediaAndAllLinks(mediaIdToRemove: RemoveMediaAndAllLinksRequest) {
        return super.post<SuccessResponse>(`/api/Mediaset/RemoveMediaAndAllLinks`, mediaIdToRemove);
    }

    public replaceMedia(media: Media) {
        return super.post<UpdateMediaResponse>(`/api/Mediaset/ReplaceMedia`, media);
    }

    public saveMediaset(mediaset: Mediaset) {
        return super.post<SaveMediasetResponse>(`/api/Mediaset/SaveMediaset`, mediaset);
    }

    public updateAudioMediaMetaData(mediaRequest: UpdateAudioMetaDataRequest) {
        return super.post<SuccessResponse>(`/api/Mediaset/UpdateAudioMediaMetaData`, mediaRequest);
    }

    public updateMedia(media: Media) {
        return super.post<UpdateMediaResponse>(`/api/Mediaset/UpdateMedia`, media);
    }
}